import { Component, OnInit, WritableSignal, signal, computed, ViewChild } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DatePickerModule } from 'primeng/datepicker';
import { TextareaModule } from 'primeng/textarea';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FeedbackService } from '../../../../../../shared/services/componentsServices/feedback.service';
import { givenFeedbackModel, givenFeedbackField, runsDataByUserRequest, currentFeedbackModel, closingTradeData } from '../../../../../../shared/models/serviceModels/request/feedbackReq.model';
import { feedbackFormsData, feedbackDataSetValues, prediction } from '../../../../../../shared/models/serviceModels/response/feedbackRes.model';
import { StandardDropdown } from '../../../../../../shared/models/components/dropdowns/standardDropdown.models';
import { DividerModule } from 'primeng/divider';
import { openTradesDataSet } from '../../../../../../shared/models/serviceModels/openTradesDataSet.model';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { PredictionSelectorComponent, RunData } from '../shared/prediction-selector/prediction-selector.component';
import { BaseFeedbackFormComponent } from '../shared/base-feedback-form.component';

@Component({
    selector: 'app-open-close-form',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
      SelectModule,
        FontAwesomeModule,
        DividerModule,
        DatePickerModule,
        TextareaModule,
        RadioButtonModule,
        PredictionSelectorComponent
    ],
    templateUrl: './open-close-form.component.html',
    styleUrl: './open-close-form.component.scss'
})
export class OpenCloseFormComponent extends BaseFeedbackFormComponent implements OnInit  {

  @ViewChild(PredictionSelectorComponent) predictionSelector!: PredictionSelectorComponent;

  

  protected givenFeedbackResponse: currentFeedbackModel = { feedbackFields: [], userId: "", userRoleId: 1, feedbackDate: new Date(), feedbackTypeId: 1};
  faSpinner: IconDefinition = faSpinner;

  isPredictionLoading = false;
  
  
  yearsDropdown:  WritableSignal<StandardDropdown[]>  = signal([]);
  monthsDropdown:  WritableSignal<StandardDropdown[]>  = signal([]);
  followedScenarioDropdown:  WritableSignal<StandardDropdown[]>  = signal([]);
  override predictionDropdown:  WritableSignal<StandardDropdown[]>  = signal([]);
  selectedPrediction: StandardDropdown= {description: "", value: ""};
  selectedFollowedScenario: StandardDropdown= {description: "", value: ""};
  selectedContract: StandardDropdown= {description: "", value: ""};
  selectedMonth: StandardDropdown= {description: "", value: ""};
  selectedYear: StandardDropdown= {description: "", value: ""};

  predictedPrice: number = 0;
  runDate: Date | undefined;
  tradeDate: Date | undefined;
  tradePrice: number = 0;
  lots: number = 0;
  freeText: string = '';
  closingDate: Date | undefined;
  closingPrice: number = 0;
  closingReasonModel: string = '';
  selectedDirection: string = '';
  isPredictedPriceDisabled: boolean = true;
  scenarioName: string = '';
  isScenarioNameDisabled: boolean = true;
  customCaseId: number | undefined;
  predictedPriceNotValid: WritableSignal<boolean> = signal(false);
  tradePriceNotValid: WritableSignal<boolean> = signal(false);
  closingPriceNotValid: WritableSignal<boolean> = signal(false);
  lotsInputNotValid: WritableSignal<boolean> = signal(false);
  scenarioNameNotValid: WritableSignal<boolean> = signal(false);
  predictionsByRunId: WritableSignal<prediction[]> = signal([]);
  override runsData: WritableSignal<RunData[]> = signal([]);  isFieldDisabled = computed(() => {
    return this.feedbackService.getFieldsStatus();
  })

  get isScenarioFieldDisabled(): boolean {
    const hasRunIdSelected = !!this.givenFeedbackResponse?.predictionRunId;
    const hasRunDateSelected = !!this.runDate;

    if (hasRunIdSelected || hasRunDateSelected) {
      return this.isFieldDisabled();
    }

    return true;
  }

  

  ngOnInit(): void {
    
    const singleData = this.feedbackService.getFormData()();

    this.feedbackFormData.set(singleData ? singleData : null);
    this.customCaseId = singleData?.customCaseId;

    this.setDropdownsValues();
    
    this.setDefaultValues();

  }

  

  setDropdownsValues(){
    this.setMonthsAndYearsDropdowns();
    this.setDefaultScenariosListByUser();
    this.setRunsListByUser();
  }

  setDefaultValues() {

    const defaultFeedbackData = this.feedbackService.getFeedbackBeforeSubmit();
    this.givenFeedbackResponse = defaultFeedbackData? defaultFeedbackData : this.givenFeedbackResponse;
    
    let formData= this.feedbackFormData();
    this.givenFeedbackResponse.predictionSourceTypeId = formData?.predictionSourceType?.feedbackFieldValues?.find(type => type.field?.toLowerCase().trim() === "prediction".toLowerCase())?.id ;
  }

  setMonthsAndYearsDropdowns(){
    let monthsArray: StandardDropdown[] = [
      { description: 'January', value: '1' },
      { description: 'February', value: '2' },
      { description: 'March', value: '3' },
      { description: 'April', value: '4' },
      { description: 'May', value: '5' },
      { description: 'June', value: '6' },
      { description: 'July', value: '7' },
      { description: 'August', value: '8' },
      { description: 'September', value: '9' },
      { description: 'October', value: '10' },
      { description: 'November', value: '11' },
      { description: 'December', value: '12' },
    ];

    this.monthsDropdown.set(monthsArray);

    let yearsArray: StandardDropdown[] = this.getYearsDropdown();
    this.yearsDropdown.set(yearsArray);

  }

  getYearsDropdown(){

    const currentYear = new Date().getFullYear() + 1;
    const startYear = 2020;

    let yearsArray: StandardDropdown[] = [];
    for (let year = startYear; year <= currentYear; year++) {
      yearsArray.push({ description: year.toString(), value: year.toString() });
    }

    return yearsArray;
  }

  setDefaultScenariosListByUser(){
    let currentData=this.feedbackFormData();
    let scenariosList: StandardDropdown[] = [];

    if(currentData?.runsCases){
      currentData?.runsCases?.feedbackFieldValues?.forEach(caseItem => {

        if(caseItem?.description?.toLowerCase().includes("actuals")) return;

        let scenarioName = caseItem.description?.split(" ")[0] || caseItem.description || "";

        scenariosList.push({ 
          description: scenarioName, 
          value: caseItem.id?.toString() || ""});

      });

      this.followedScenarioDropdown.set(scenariosList);
    }
   
  }




  onPredictionSelectionChange(event: any) {

    this.isPredictedPriceDisabled = true;
    this.runDate=undefined;
    this.predictedPrice=0;
    this.isScenarioNameDisabled = true;
    this.scenarioName = '';
    this.scenarioNameNotValid.set(false);

    let formData= this.feedbackFormData();

    this.givenFeedbackResponse = {
      ...this.givenFeedbackResponse,
      predictionSourceTypeId: formData?.predictionSourceType?.feedbackFieldValues?.find(type => type.field?.toLowerCase().trim() === "prediction".toLowerCase())?.id,
      predictionRunId: event.value.value,
      predictionRunDate: new Date(event.value.description)
    };

    this.feedbackService.setFeedbackValues(this.givenFeedbackResponse!);

  

    this.getPredictionData();
    
  }

  // Handler for the new prediction-selector component
  override onRunSelected(runData: RunData) {
    this.isPredictedPriceDisabled = true;
    this.runDate = undefined;
    this.isScenarioNameDisabled = true;
    this.scenarioName = '';
    this.scenarioNameNotValid.set(false);
    super.onRunSelected(runData);
  }  getPredictionData(){
    this.isPredictionLoading = true;
    let request:runsDataByUserRequest= this.mapGetPredictionsByRunIdRequest();

    this.feedbackService.getPredictionsByUser(request).subscribe({
      next: (response) => {
        this.isPredictionLoading = false;
        if(response.errorMsg || !response.predictions || response.predictions.length === 0) return;   
        
        this.predictionsByRunId.set(response.predictions || []);
        this.mapPredictionDataToFeedbackResponse(response.predictions);
      },
      error: (error) => {
        this.isPredictionLoading = false;
        console.error('Error fetching predictions by user:', error);
      }
    });
   
  }

  mapPredictionDataToFeedbackResponse(predictions: prediction[]) {

    this.setScenariosByRunId(predictions);
    this.selectDefaultScenario();

  }

  selectDefaultScenario(): void {
    const scenarios = this.followedScenarioDropdown();
    
    if (scenarios.length > 0) {
      const firstScenario = scenarios[0];
      this.selectedFollowedScenario = firstScenario;
      
      const currentIndex = this.predictionsByRunId().findIndex(
        pred => pred.id?.toString() === firstScenario.value
      );
      
      if (currentIndex !== -1) {
        this.setPriceValueInInputField(currentIndex);
      }
      
      const originalCaseName = firstScenario.originalValue || firstScenario.description;
      this.storeDropdownValuesIntoFeedbackResponse(this.selectedFollowedScenario, 'scenario', originalCaseName);
      this.checkIfAllMandatoryFieldsAreFilled();
    }
  }

  setScenariosByRunId(predictions: prediction[]){
    let scenariosList: StandardDropdown[] = [];
    const formData = this.feedbackFormData();
    const manualSourceTypeId = formData?.predictionSourceType?.feedbackFieldValues?.find(
      type => type.field?.toLowerCase().trim() === "manual"
    )?.id;

    predictions.forEach(prediction => {
      let displayName = prediction.case_name || "";
      
      if (manualSourceTypeId && prediction.source_type_id === manualSourceTypeId) {
        displayName = `${displayName} - Manual`;
      }

      scenariosList.push({ 
        description: displayName,
        value: prediction.id?.toString() || "",
        originalValue: prediction.case_name || "" 
          }); 

    })

    this.followedScenarioDropdown.set(scenariosList);
  }

  setPriceValueInInputField ( index: number){

    let predictions = this.predictionsByRunId();

    let predictedPriceValue = parseFloat((predictions[index].value || 0).toFixed(3));
    this.predictedPrice = predictedPriceValue;
    this.storeInputsValuesIntoFeedbackResponse(predictedPriceValue, 'predicted_price');
    this.checkIfAllMandatoryFieldsAreFilled();

  }

  mapGetPredictionsByRunIdRequest(): runsDataByUserRequest{
    let request:runsDataByUserRequest = {
      runIds: this.givenFeedbackResponse.relatedRunIds?.map(id => id.toString())
    };

    return request;
  }

  setManualControllersToDefault(){

    let formData= this.feedbackFormData();
    this.givenFeedbackResponse.predictionSourceTypeId = formData?.predictionSourceType?.feedbackFieldValues?.find(type => type.field?.toLowerCase().trim() === "manual".toLowerCase())?.id || 1;

    this.isPredictedPriceDisabled = false;
    this.setDefaultScenariosListByUser();
    
  }

  onRunDateChange(event: any) {

    this.setManualControllersToDefault();

    this.selectedPrediction= {description: "", value: ""};
    this.selectedFollowedScenario= {description: "", value: ""};
    this.predictedPrice=0;
   
    const runDate = new Date(event);
    this.runDate= runDate;

    if (this.predictionSelector) {
      this.predictionSelector.clearSelection();
    }

    this.givenFeedbackResponse = {
      ...this.givenFeedbackResponse,
      predictionRunId: undefined,
      predictionRunDate: runDate
    };
    
    this.isScenarioNameDisabled = true;
    this.scenarioName = '';
    this.scenarioNameNotValid.set(false);
    
    this.feedbackService.setFeedbackValues(this.givenFeedbackResponse!);
    this.checkIfAllMandatoryFieldsAreFilled();
  }

  
  onFollowedScenarioChange(event: any) {
    if (!event.value || !event.value.value) {
      this.predictedPrice = 0;
      this.isPredictedPriceDisabled = true;
      this.isScenarioNameDisabled = true;
      this.scenarioName = '';
      this.scenarioNameNotValid.set(false);
      this.checkIfAllMandatoryFieldsAreFilled();
      return;
    }

    let currentIndex = this.predictionsByRunId().findIndex(pred => pred.id?.toString() === event.value.value);
    
    if(!this.runDate){
      this.setPriceValueInInputField(currentIndex);
    } else {
      // In manual mode (runDate is set), enable the predicted price field
      this.isPredictedPriceDisabled = false;
    }
   
    const originalCaseName = event.value.originalValue || event.value.description;
    this.storeDropdownValuesIntoFeedbackResponse(this.selectedFollowedScenario, 'scenario', originalCaseName);
    
    const isManualSelection = !!this.runDate && !this.givenFeedbackResponse?.predictionRunId;
    const isCustomScenario = this.selectedFollowedScenario.description?.toLowerCase().includes('custom');
    
    this.isScenarioNameDisabled = !(isManualSelection && isCustomScenario);
    
    if (this.isScenarioNameDisabled) {
      this.scenarioName = '';
      this.scenarioNameNotValid.set(false);
    }
    
    this.checkIfAllMandatoryFieldsAreFilled();
  }

  onScenarioNameChange(event: any) {
    if (!this.isScenarioNameDisabled && this.scenarioName.trim() === '') {
      this.scenarioNameNotValid.set(true);
    } else {
      this.scenarioNameNotValid.set(false);
    }
    
    this.storeInputsValuesIntoFeedbackResponse(this.scenarioName, 'scenario_name');
    this.checkIfAllMandatoryFieldsAreFilled();
  }  

  validateTradePrice(event:any){
    let tradePrice = event.currentTarget.value;

    if (tradePrice === ""|| isNaN(tradePrice) || tradePrice <= 0) {
      this.tradePrice = 0; // Clear the model
      this.tradePriceNotValid.set(true);
      this.checkIfAllMandatoryFieldsAreFilled();
      return;
    } 
      // this.tradePrice = tradePrice;
      this.tradePriceNotValid.set(false);

    this.storeInputsValuesIntoFeedbackResponse(tradePrice, 'trade_price');
    this.checkIfAllMandatoryFieldsAreFilled();
  }

  onDirectionChange(){

    const formFieldsData = this.feedbackFormData();
    let formFeedbackField = formFieldsData?.directions?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === this.selectedDirection.toString().toLowerCase());

    if(formFeedbackField){
      this.storeInputsValuesIntoFeedbackResponse(formFeedbackField?.id ?? 0, 'direction');

      this.givenFeedbackResponse= {
        ...this.givenFeedbackResponse,
        closingTradeData: {
          ...this.givenFeedbackResponse.closingTradeData,
          tradeDirection: this.selectedDirection.toString()
      }};


      this.checkIfAllMandatoryFieldsAreFilled();
    }

    // this.storeInputsValuesIntoFeedbackResponse(this.selectedDirection, 'direction');
    // this.checkIfAllMandatoryFieldsAreFilled();
  }

  validatePredictedPrice(event:any){
    //develop logic here
    let predictedPrice = event.currentTarget.value;

    if (predictedPrice === "" || isNaN(predictedPrice)) {
      this.predictedPrice = 0; // Clear the model
      this.predictedPriceNotValid.set(true);
      this.checkIfAllMandatoryFieldsAreFilled();
      return;
    } 

     
    this.predictedPriceNotValid.set(false);

    this.storeInputsValuesIntoFeedbackResponse(predictedPrice, 'predicted_price');
    this.checkIfAllMandatoryFieldsAreFilled();
  }

  onMonthDropdownChange(event: any) {
    
    this.storeDropdownValuesIntoFeedbackResponse(this.selectedMonth, 'month');
    this.checkIfAllMandatoryFieldsAreFilled();
  }

  onYearDropdownChange(event: any) {
    
    this.storeDropdownValuesIntoFeedbackResponse(this.selectedYear, 'year');
    this.checkIfAllMandatoryFieldsAreFilled();
  } 

  preventDecimalInput(event: KeyboardEvent): void {
    if (event.key === '.' || event.key === ',' || event.key === '-' || event.key === 'e' || event.key === 'E') {
      event.preventDefault();
    }
  }

  validateLotsQty(event:any){
    let lotsQty = event.currentTarget.value;

    if (lotsQty === "" || isNaN(lotsQty) || lotsQty < 0 || !Number.isInteger(Number(lotsQty))) {
      this.lots = 0; // Clear the model
      this.lotsInputNotValid.set(true);
      this.checkIfAllMandatoryFieldsAreFilled();
      return;
    } 
      // this.lots = lotsQty;
      this.lotsInputNotValid.set(false);

      this.storeInputsValuesIntoFeedbackResponse(lotsQty, 'lots');
      this.checkIfAllMandatoryFieldsAreFilled();
  }

  validateClosingPrice(event:any){
    let closingPrice = event.currentTarget.value;

    if (closingPrice === ""|| isNaN(closingPrice) || closingPrice <= 0) {
      this.closingPrice = 0; // Clear the model
      this.closingPriceNotValid.set(true);
      this.checkIfAllMandatoryFieldsAreFilled();
      return;
    }

    this.closingPrice = closingPrice;
    this.closingPriceNotValid.set(false);

    this.givenFeedbackResponse= {
      ...this.givenFeedbackResponse,
      closingTradeData: {
        ...this.givenFeedbackResponse.closingTradeData,
        closingPrice: closingPrice
    }};

    this.storeInputsValuesIntoFeedbackResponse(closingPrice, 'closing_price');
    this.checkIfAllMandatoryFieldsAreFilled();
  }

  validateFreeText(event:any){
    let freeText = this.freeText;

    const sanitizedText = freeText.replace(/[^a-zA-Z0-9 .,!?'"()\-$\/#@%]/g, '');

    const wordCount = sanitizedText.trim().split(/\s+/).length;
    this.checkIfAllMandatoryFieldsAreFilled();

    if (wordCount >= 2) {
      this.storeFreeText(sanitizedText);
    }

    // this.storeFreeText(sanitizedText);
    // this.checkIfAllMandatoryFieldsAreFilled();
  }

  storeFreeText(freeText: string){

    const formFieldsData = this.feedbackFormData();
    let formFeedbackField = formFieldsData?.feedbackFields?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === "free_text".toLowerCase());

    let feedbackField: givenFeedbackField = {
      dataTypeId: formFeedbackField?.dataTypeId || 0,
      fieldId: formFeedbackField?.id,
      fieldName: formFeedbackField?.field || "",
      fieldDescription: formFeedbackField?.description || "",
      value: freeText
    };
    this.storeFeedbackField(feedbackField);
  }

  //Check!!!
  storeFeedbackField(givenFeedbackField:givenFeedbackField){


    let existingFieldIndex = this.givenFeedbackResponse.feedbackFields.findIndex(field => field.fieldName === givenFeedbackField.fieldName);

    if (existingFieldIndex !== -1) {
      this.givenFeedbackResponse.feedbackFields[existingFieldIndex] = givenFeedbackField;
    } else {
      this.givenFeedbackResponse.feedbackFields.push(givenFeedbackField);
    }

    this.feedbackService.setFeedbackValues(this.givenFeedbackResponse!);

  }

  
  onReasonChange(){

    const formFieldsData = this.feedbackFormData();
    let formFeedbackField = formFieldsData?.closingReasons?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === this.closingReasonModel.toString().toLowerCase());

    if(formFeedbackField){

      this.givenFeedbackResponse= {
        ...this.givenFeedbackResponse,
        closingTradeData: {
          ...this.givenFeedbackResponse.closingTradeData,
          closingReasonId: formFeedbackField.id
      }};

      // this.storeInputsValuesIntoFeedbackResponse(formFeedbackField?.id ?? 0, 'reason');
      this.checkIfAllMandatoryFieldsAreFilled();
    }

  }


  //Check!!!
  storeDropdownValuesIntoFeedbackResponse(value: StandardDropdown, type: string, extraDescription?: string){

    const formFieldsData = this.feedbackFormData();
    let feedbackField: givenFeedbackField = {dataTypeId: 0, fieldName: "", value: ""};

    let formFeedbackField: feedbackDataSetValues | undefined;
      
    switch(type){
      
      case 'scenario':

        
          formFeedbackField = formFieldsData?.feedbackFields?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === "scenario".toLowerCase());
         
          feedbackField = {
            dataTypeId: formFeedbackField?.dataTypeId || 0,
            fieldId: formFeedbackField?.id,
            fieldName: formFeedbackField?.field || "",
            fieldDescription: formFeedbackField?.description || "",
            value: value.value,
            extraDescription: extraDescription || ""
          };

          this.storeFeedbackField(feedbackField);
        
          break;

      
      case 'month':
      case 'year':

          let contractValue= `${this.selectedMonth.value}-${this.selectedYear.value}`;

          this.givenFeedbackResponse= {
            ...this.givenFeedbackResponse,
            closingTradeData: {
              ...this.givenFeedbackResponse.closingTradeData,
              tradeContract: contractValue
          }};
    
          
          formFeedbackField = formFieldsData?.feedbackFields?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === "contract".toLowerCase());
         
          feedbackField = {
            dataTypeId: formFeedbackField?.dataTypeId || 0,
            fieldId: formFeedbackField?.id,
            fieldName: formFeedbackField?.field || "",
            fieldDescription: formFeedbackField?.description || "",
            value: contractValue
          };

          this.storeFeedbackField(feedbackField);

        break;
      


      default:
        break;
    }

  }

  //Check!!!
  storeInputsValuesIntoFeedbackResponse(value:number | string, type: string){

    const formFieldsData = this.feedbackFormData();


    switch(type){

      case 'trade_price':
        {
        
            let formFeedbackField = formFieldsData?.feedbackFields?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === "trade_price".toLowerCase());
          
            let feedbackField: givenFeedbackField = {
              dataTypeId: formFeedbackField?.dataTypeId || 0,
              fieldId: formFeedbackField?.id,
              fieldName: formFeedbackField?.field || "",
              fieldDescription: formFeedbackField?.description || "",
              value: value.toString()
            };
    
            this.storeFeedbackField(feedbackField);

            this.givenFeedbackResponse= {
              ...this.givenFeedbackResponse,
              closingTradeData: {
                ...this.givenFeedbackResponse.closingTradeData,
                tradeEntryPrice: this.tradePrice
            }};
    
            break; 
          }
          
      case 'predicted_price':

          {
            
            let formFeedbackField = formFieldsData?.feedbackFields?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === "predicted_price".toLowerCase());
           
            let feedbackField: givenFeedbackField = {
              dataTypeId: formFeedbackField?.dataTypeId || 0,
              fieldId: formFeedbackField?.id,
              fieldName: formFeedbackField?.field || "",
              fieldDescription: formFeedbackField?.description || "",
              value: value.toString()
            };

            this.storeFeedbackField(feedbackField);

            break; 
          }
      case 'lots':
        {
          
          let formFeedbackField = formFieldsData?.feedbackFields?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === "lots".toLowerCase());
         
          this.givenFeedbackResponse= {
            ...this.givenFeedbackResponse,
            closingTradeData: {
              ...this.givenFeedbackResponse.closingTradeData,
              tradeLots: this.lots
          }};
        
          let feedbackField: givenFeedbackField = {
            dataTypeId: formFeedbackField?.dataTypeId || 0,
            fieldId: formFeedbackField?.id,
            fieldName: formFeedbackField?.field || "",
            fieldDescription: formFeedbackField?.description || "",
            value: value.toString()
          };

          this.storeFeedbackField(feedbackField);

          break; 
        }

      case 'free_text':
        {
         
          let formFeedbackField = formFieldsData?.feedbackFields?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === "free_text".toLowerCase());
         
          let feedbackField: givenFeedbackField = {
            dataTypeId: formFeedbackField?.dataTypeId || 0,
            fieldId: formFeedbackField?.id,
            fieldName: formFeedbackField?.field || "",
            fieldDescription: formFeedbackField?.description || "",
            value: value.toString()
          };

          this.storeFeedbackField(feedbackField);

          break; 
        }
        
        case 'direction':
        {
          
          let formFeedbackField = formFieldsData?.feedbackFields?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === "direction".toLowerCase());
         
          let feedbackField: givenFeedbackField = {
            dataTypeId: formFeedbackField?.dataTypeId || 0,
            fieldId: typeof value === 'number' ? value : undefined,
            // fieldId: formFeedbackField?.id,
            fieldName: formFeedbackField?.field || "",
            fieldDescription: formFeedbackField?.description || "",
            value: value.toString()
          };

          this.storeFeedbackField(feedbackField);

          break; 
        }

      case 'scenario_name':
        {
          let feedbackField: givenFeedbackField = {
            dataTypeId: 2, 
            fieldName: "scenario_name",
            fieldDescription: "Scenario name",
            value: value.toString()
          };

          this.storeFeedbackField(feedbackField);

          break;
        }

      default:
        break;
      
      }
  
  }

  checkIfAllMandatoryFieldsAreFilled(){
    let areMandatoryFieldsFilled = false;
    let runDate = this.givenFeedbackResponse.predictionRunDate;
    let closingDate = this.givenFeedbackResponse.closingTradeData?.closingDate;

    const isScenarioNameRequired = !this.isScenarioNameDisabled && this.scenarioName.trim() === '';
    
    if (
      this.selectedFollowedScenario.value &&
      !isNaN(this.predictedPrice) &&
      this.selectedMonth.value.length > 0 &&
      this.selectedYear.value.length > 0 &&
      this.selectedDirection &&
      this.tradePrice > 0 &&
      this.lots > 0 &&
      this.freeText.trim().split(/\s+/).length >=2 &&
      // this.freeText.trim() !== '' &&
      runDate &&
      this.tradeDate &&
      this.closingPrice > 0 &&
      this.closingReasonModel.trim() !== '' &&
      closingDate &&
      !isScenarioNameRequired 
    ) {
      areMandatoryFieldsFilled = true;
    }
    
    this.feedbackService.setAreMandatoryFieldsLoaded(areMandatoryFieldsFilled);
  }

  
  onTradeDateChange(event: any) {
    const tradeDate = new Date(event);
    this.tradeDate= tradeDate;

    this.givenFeedbackResponse.tradeDate = tradeDate;

    this.givenFeedbackResponse= {
      ...this.givenFeedbackResponse,
      closingTradeData: {
        ...this.givenFeedbackResponse.closingTradeData,
        tradeDate: tradeDate
    }};

    this.feedbackService.setFeedbackValues(this.givenFeedbackResponse!);
    this.checkIfAllMandatoryFieldsAreFilled();
  }

  
  onClosingDateChange(event: any) {
    const closingDate = new Date(event);
    this.closingDate= closingDate;

    this.givenFeedbackResponse= {
      ...this.givenFeedbackResponse,
      closingTradeData: {
        ...this.givenFeedbackResponse.closingTradeData,
        closingDate: closingDate
      }
    };

    this.feedbackService.setFeedbackValues(this.givenFeedbackResponse);
    this.checkIfAllMandatoryFieldsAreFilled();
  }

}
